import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LoginModule } from './login/login.module';
import { ArticleModule } from './article/article.module';
import { VendorModule } from './vendor/vendor.module';
import { ReceiptModule } from './receipt/receipt.module';
import { CustomerModule } from './customer/customer.module';
import { OrderModule } from './order/order.module';
import { LocationModule } from './location/location.module';
import { StockModule } from './stock/stock.module';
import { TaskModule } from './task/task.module';

import { SharedDataService } from './shared-data.service';
import { ConfigurationDataService } from './configuration-data.service';

import { MenuModule,MenuItem } from 'primeng/primeng';
import { GUILogicService } from './guilogic.service';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    LoginModule,
    ArticleModule,
    VendorModule,
    BrowserAnimationsModule,
    MenuModule,
    ReceiptModule,
    CustomerModule,
    OrderModule,
    LocationModule,
    StockModule,
    TaskModule
  ],
  exports: [
    AppRoutingModule,
  ],
  providers: [SharedDataService, ConfigurationDataService, GUILogicService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/app.module.ts